import { render, staticRenderFns } from "./OpportunitiesBlock.vue?vue&type=template&id=b0a37fe0"
import script from "./OpportunitiesBlock.vue?vue&type=script&lang=js"
export * from "./OpportunitiesBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports